import { VOICE_TOKEN_ERROR, type VoiceTokenErrorCode } from '@deadpan/shared';
import type { Translations } from '@deadpan/shared';

export function messageForVoiceError(code: VoiceTokenErrorCode, ui: Translations['ui']): string {
  switch (code) {
    case VOICE_TOKEN_ERROR.NOT_IN_GAME_ROOM:
      return ui.voiceErrNotInGameRoom;
    case VOICE_TOKEN_ERROR.ROOM_NOT_FOUND:
      return ui.voiceErrRoomNotFound;
    case VOICE_TOKEN_ERROR.VOICE_NOT_SET:
      return ui.voiceErrVoiceNotSet;
    case VOICE_TOKEN_ERROR.INVALID_PASSWORD:
      return ui.voiceErrInvalidPassword;
    case VOICE_TOKEN_ERROR.VOICE_SERVER_NOT_CONFIGURED:
      return ui.voiceErrVoiceServerNotConfigured;
    case VOICE_TOKEN_ERROR.INTERNAL:
    default:
      return ui.voiceErrInternal;
  }
}
